export default class FinesseSidebar extends HTMLElement {
  active: boolean = false

  sidebar: HTMLElement | null = null
  linksHasList: NodeListOf<HTMLElement> | null = null
  singleLinks: NodeListOf<HTMLElement> | null = null
  closeButton: HTMLElement | null = null

  static get observedAttributes() {
    return ['active']
  }

  constructor() {
    super()

    this.className = 'fixed top-0 left-[-100vw] flex justify-start z-20 w-full h-full transition-all duration-500 mobile:!z-60'

    this.sidebar = this.querySelector<HTMLElement>('aside[data-sidebar]') as HTMLElement
    this.closeButton = this.querySelector<HTMLElement>('button[data-sidebar-close]') as HTMLElement

    (window as any).addEventListener('sidebar:toggle', this.handleSidebar.bind(this))

    this.closeButton.addEventListener('click', this.handleClick.bind(this))
    this.sidebar.addEventListener('mouseleave', this.handleClick.bind(this))

    // add event listeners to links with child lists
    this.linksHasList = this.querySelectorAll('a[data-has-childlist]')
    this.singleLinks = this.querySelectorAll('a[data-single-link]')

    if (this?.linksHasList?.length > 0) {
      this.linksHasList.forEach(link => {
        link.addEventListener('mouseover', this.handleLinkHasList.bind(this))
      })
    }

    if (this?.singleLinks?.length > 0) {
      this.singleLinks.forEach(link => {
        link.addEventListener('mouseover', this.handleHideAllLists.bind(this))
      })
    }
  }

  get isActive() {
    return this.active
  }

  set isActive(value: boolean) {
    this.active = value
    this.setAttribute('active', value.toString())
    this.toggle()
  }

  handleLinkHasList(evt: Event) {
    evt.preventDefault()

    const link = evt.target as HTMLElement
    const list = link.nextElementSibling as HTMLElement

    const childLists = this.querySelectorAll('div[data-sidebar-childlist]')

    // hide all other childLists
    childLists.forEach((childList: Element) => {
      const htmlChildList = childList as HTMLElement;
      if (htmlChildList !== list && !htmlChildList.classList.contains('hidden')) {
        htmlChildList.classList.add('hidden')
      }
    })

    if (list && list.classList.contains('hidden')) {
      list.classList.remove('hidden')
    }
  }

  handleHideAllLists() {
    const childLists = this.querySelectorAll('div[data-sidebar-childlist]')

    // hide all other childLists
    childLists.forEach((childList: Element) => {
      const htmlChildList = childList as HTMLElement;
      if (!htmlChildList.classList.contains('hidden')) {
        htmlChildList.classList.add('hidden')
      }
    })
  }

  handleSidebar(evt: CustomEvent) {
    // @ts-ignore
    this.isActive = evt.detail.active
  }

  handleClick(evt: Event) {
    evt.preventDefault()

    const isCloseButton = evt.target === this.closeButton || (evt.target as HTMLElement).hasAttribute('data-sidebar-close')
    const isSidebar = evt.target === this.sidebar || (evt.target as HTMLElement).hasAttribute('data-sidebar')
 
    if (evt.target === this || isCloseButton || isSidebar) {
      window.dispatchEvent(new CustomEvent('sidebar:toggle', { bubbles: true, detail: { active: false } }))
    }
  }

  toggle() {
    if (this.isActive) {
      this.classList.add('!left-0')
    } else {
      this.classList.remove('!left-0')
      this.handleHideAllLists()
    }
  }
}

customElements.define('finesse-sidebar', FinesseSidebar)

